export default "__VITE_ASSET__YRH_lqax__"